import { render, staticRenderFns } from "./WallAngleMark.vue?vue&type=template&id=94e50d82&scoped=true"
import script from "./WallAngleMark.vue?vue&type=script&lang=js"
export * from "./WallAngleMark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e50d82",
  null
  
)

export default component.exports